<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<h2 class="h2t">Contents</h2>
<p class="tocchap"><a href="#/xhtml/intro#intro"><span class="f3">INTRODUCTION</span></a></p>
<p class="toctitle"><a href="#/xhtml/intro">Slow Cooker Love</a></p>
<p class="tocchap"><a href="#/xhtml/ch01"><span class="f3">CHAPTER 1</span></a></p>
<p class="toctitle"><a href="#/xhtml/ch01#ch01">Vegan Slow Cooker Basics</a></p>
<p class="tocchap"><a href="#/xhtml/ch02"><span class="f3">CHAPTER 2</span></a></p>
<p class="toctitle"><a href="#/xhtml/ch02#ch02">No-Time-to-Prep Recipes</a></p>
<p class="tocchap"><span href="#/xhtml/ch03" title="Link target outside of Sample"><span class="f3">CHAPTER 3</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Soups</span></p>
<p class="tocchap"><span href="#/xhtml/ch04" title="Link target outside of Sample"><span class="f3">CHAPTER 4</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Stews</span></p>
<p class="tocchap"><span href="#/xhtml/ch05" title="Link target outside of Sample"><span class="f3">CHAPTER 5</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Casseroles &amp; Loaves</span></p>
<p class="tocchap"><span href="#/xhtml/ch06" title="Link target outside of Sample"><span class="f3">CHAPTER 6</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Pasta &amp; Grains</span></p>
<p class="tocchap"><span href="#/xhtml/ch07" title="Link target outside of Sample"><span class="f3">CHAPTER 7</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Mains</span></p>
<p class="tocchap"><span href="#/xhtml/ch08" title="Link target outside of Sample"><span class="f3">CHAPTER 8</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Sides</span></p>
<p class="tocchap"><span href="#/xhtml/ch09" title="Link target outside of Sample"><span class="f3">CHAPTER 9</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Sandwich &amp; Taco Fillings</span></p>
<p class="tocchap"><span href="#/xhtml/ch10" title="Link target outside of Sample"><span class="f3">CHAPTER 10</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Breads</span></p>
<p class="tocchap"><span href="#/xhtml/ch11" title="Link target outside of Sample"><span class="f3">CHAPTER 11</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Snacks &amp; Appetizers</span></p>
<p class="tocchap"><span href="#/xhtml/ch12" title="Link target outside of Sample"><span class="f3">CHAPTER 12</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Breakfasts</span></p>
<p class="tocchap"><span href="#/xhtml/ch13" title="Link target outside of Sample"><span class="f3">CHAPTER 13</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Desserts</span></p>
<p class="tocchap"><span href="#/xhtml/ch14" title="Link target outside of Sample"><span class="f3">CHAPTER 14</span></span></p>
<p class="toctitle"><span href="#/xhtml/ch14#ch14" title="Link target outside of Sample">Staples</span></p>
<p class="tocchap1"><span href="#/xhtml/appex" title="Link target outside of Sample"><span class="f3">APPENDIX</span></span></p>
<p class="tocchap1"><span href="#/xhtml/ack" title="Link target outside of Sample"><span class="f3">ACKNOWLEDGMENTS</span></span></p>
<p class="tocchap1"><span href="#/xhtml/about" title="Link target outside of Sample"><span class="f3">ABOUT THE AUTHOR</span></span></p>
<p class="tocchap1"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="f3">INDEX</span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?87e38b2c